import type { Product } from "../types";

export const products: Product[] = [
  {
    id: "dubai-cookie",
    name: "Dubai Chewy Cookie",
    category: "Dubai & Fudge",
    priceCents: 600,
    description: "Chocolate-marshmallow outside. Pistachio-kataifi centre.",
    image: "/products/dubai-cookie.jpg",
    alt: "Sub Zero Treats Dubai Chewy Cookie",
  },
  {
    id: "puff-clusters",
    name: "Puff Clusters",
    category: "Freeze-dried",
    priceCents: 1000,
    description: "Bright, airy clusters with a serious crunch.",
    image: "/products/puff-clusters.jpg",
    alt: "Colourful freeze-dried Puff Clusters",
  },
  {
    id: "rainbow-treats",
    name: "Rainbow Treats",
    category: "Freeze-dried",
    priceCents: 1000,
    description: "A familiar rainbow favourite, transformed.",
    image: "/products/rainbow-treats.jpg",
    alt: "Freeze-dried Rainbow Treats",
  },
  {
    id: "dubai-chocolate",
    name: "Dubai Chocolate Bar",
    category: "Dubai & Fudge",
    priceCents: 2495,
    description: "Founder-made chocolate with a pistachio crunch.",
    image: "/products/dubai-chocolate.jpg",
    alt: "Handmade Dubai Chocolate Bar",
  },
  {
    id: "fudge",
    name: "Fudge",
    category: "Dubai & Fudge",
    priceCents: 600,
    description: "A rich little add-on for the treat box.",
    image: "/products/fudge.jpg",
    alt: "Sub Zero Treats fudge",
  },
  {
    id: "pick-mix",
    name: "Pick & Mix 200g",
    category: "Pick & Mix",
    priceCents: 700,
    description: "Build the bag exactly the way you want it.",
    image: "/products/pick-mix-higgsfield.webp",
    alt: "Colourful freeze-dried pick and mix treats bursting from a cream bucket",
  },
];

export const mixOptions = [
  "Rainbow",
  "Sour rainbow",
  "Puff clusters",
  "Strawberry",
  "Caramel",
  "Marshmallows",
] as const;

export const bagSizes = [
  { grams: 200, priceCents: 700 },
  { grams: 400, priceCents: 1400 },
  { grams: 600, priceCents: 2100 },
] as const;
